import React from 'react';
import { useCartContext } from '../context/CartContext';
import { getServiceOfferings } from '../../parseServiceOfferings';
import { Portal } from '../../../components/portal/Portal';
import { addServiceOffering } from '../addServiceOffering';
import ProductService from '../../../templates/components/pdp/productService/ProductService';
import { ServiceIds } from '../../constants/services';
import { tryParseJson } from '@jbhi-fi/utils/src/JSON/tryParseJson';
import { getProductServiceVariantId } from '../../../templates/components/pdp/utils/product-service';
import { LineItemProps, ServiceOffering } from '@jbhi-fi/apis/src/services/types';
import { JbCartItem } from '@jbhi-fi/apis/src/shopify/types/JbCart';

export const getServiceOfferingsKey = (lineItem: JbCartItem): string => {
  return lineItem.line_id;
};

export const ServiceOfferings = () => {
  const { cart, location } = useCartContext();
  const serviceOfferings = getServiceOfferings();
  if (!serviceOfferings) return null;

  return (
    <>
      {cart?.items?.map((cartLineItem, cartLineItemIndex) => {
        const serviceOfferingsKey = getServiceOfferingsKey(cartLineItem);
        const container = window.document.getElementById(cartLineItem.line_id);
        const serviceOffering = serviceOfferings[serviceOfferingsKey] as Array<ServiceOffering>;
        const fullServiceOffering = serviceOfferings[`${serviceOfferingsKey}|fullOffering`] as LineItemProps;

        if (!container || !serviceOffering || !serviceOffering.length) return;

        const uniqueServices = [
          serviceOffering.find(o => o.typeId === ServiceIds.ExtraCare),
          serviceOffering.find(o => o.typeId === ServiceIds.MobileExtras),
          serviceOffering.find(o => o.typeId === ServiceIds.ExtraCareNz),
          serviceOffering.find(o => o.typeId === ServiceIds.AppleCareNz),
        ].filter(Boolean);

        return (
          <Portal container={container} key={cartLineItemIndex}>
            {uniqueServices?.map((offeringData, i) => {
              if (!offeringData?.shouldRender) return;
              const { variantId, sku, priceInc, typeId } = offeringData;

              if (!variantId) {
                console.error(
                  `Algolia product data missing for service suggestion, primary item sku ${cartLineItem.sku}, suggestion sku: ${sku}`
                );
                return;
              }

              const handleAdd = async (offeringId?: string) => {
                const offering = offeringId ? serviceOffering.filter(o => o.id.includes(offeringId))[0] : offeringData;
                let shopifyVariantId = offering?.variantId;
                if (typeId === ServiceIds.ExtraCare) {
                  shopifyVariantId = await getProductServiceVariantId(sku, 'extra-care', priceInc);
                }

                if (!shopifyVariantId) return;

                await addServiceOffering({
                  variantId: shopifyVariantId,
                  location,
                  googleTagManager: tryParseJson(cartLineItem?.properties?._gtmProduct || '{}'),
                  serviceData: offering,
                  primaryLineItem: cartLineItem,
                });
              };

              return (
                <div key={i}>
                  <ProductService
                    serviceType={typeId}
                    suggestions={[fullServiceOffering]}
                    onAdd={handleAdd}
                    productSku={cartLineItem.sku}
                    gtmData={tryParseJson(cartLineItem.properties._gtmProduct || '{}')}
                  />
                </div>
              );
            })}
          </Portal>
        );
      })}
    </>
  );
};
